// extracted by mini-css-extract-plugin
module.exports =  {"container":"_0bc5e8de02--container--J_Y2l","icon-container":"_0bc5e8de02--icon-container--Gg6ca","arrow":"_0bc5e8de02--arrow--Sceq4","icon":"_0bc5e8de02--icon--u0qCl"};